import { createFileRoute } from "@tanstack/react-router";
import { RoofingServicePage } from "@/components/RoofingServicePage";
import { roofingServicePages } from "@/data/roofingServiceContent";

const c = roofingServicePages["commercial-roofing"];

export const Route = createFileRoute("/services/commercial-roofing")({
  head: () => ({
    meta: [
      { title: "Commercial Roofing Southern California | McKay Roofing & Solar" },
      { name: "description", content: "Commercial roofing in Southern California – repairs, maintenance and replacements for offices, warehouses and retail buildings." },
      { property: "og:title", content: "Commercial Roofing – McKay Roofing & Solar" },
      { property: "og:description", content: c.heroSubtitle },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mckay.steadyautogrowthdemo.com/services/commercial-roofing" }],
  }),
  component: () => <RoofingServicePage {...c} />,
});